import React from 'react'
import { Route } from 'react-router-dom'
import NotFound from '../../../components/NotFound'

const getDefaultRoutes = (appConfig) => {
  const { pages } = appConfig || {}
  const { PageNotFound = () => NotFound } = pages || {}

  return [<Route component={PageNotFound} />]
}

export default getDefaultRoutes
